import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, ProgressBar } from 'react-bootstrap';
import config from './config.json';

const Step20 = ({ prevStep, nextStep, setStep }) => {

  const currentStep = 20;
  const [location, setLocation] = useState('');
  const tableauValeurs = JSON.parse(localStorage.getItem('work_types'));

  useEffect(() => {
    // Récupère la valeur du localStorage lors du chargement initial du composant
    const storedValue = localStorage.getItem('location');
    if (storedValue) {
      setLocation(storedValue);
    }
  }, []);

  const nextSteps = () => {

    if(tableauValeurs.includes('pompe à chaleur hybride')) {
      nextStep();
     }
     else if(tableauValeurs.includes('Chaudière gaz à condensation')) {
      setStep(23);
     }
     else if(tableauValeurs.includes('radiateur électrique')) {
      setStep(25);
     }
     else if(tableauValeurs.includes('chaudière bois')) {
      setStep(26);
     }
     else if(tableauValeurs.includes('poêle à bois')) {
      setStep(28); 
     } 
     else {
       setStep(29);
     }
  }

  const handleChange = (event) => {
    const { value } = event.target;
    setLocation(value);
    localStorage.setItem('location', value);
    nextSteps();
  };      
   
   const handleSubmit = (e) => {
    e.preventDefault();
    nextSteps();   
   };

        return (
            <Container>
              <ProgressBar
                now={(currentStep / 36) * 100}
                style={{ backgroundColor: "#bad7f1" }}
              >
              <ProgressBar
                now={(currentStep / 36) * 100}
                style={{ backgroundColor: "#0be288" }}
              />
              </ProgressBar>
              <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col>
                      <h2>{config.step20.step}</h2>
                      <h3>{config.step20.title}</h3>
                  </Col>
                </Row>
                <Row className="mb-3 container-bloc">
                  <Col className={`m-2 icon-container ${location === "oui" ? 'selected' : ''}`}>
                        <Form.Check
                          type="radio"
                          label="Oui"
                          value="oui"
                          checked={location === "oui"}
                          onChange={handleChange}
                        />
                    </Col>
                    <Col className={`m-2 icon-container ${location === "non" ? 'selected' : ''}`}>
                        <Form.Check
                          type="radio"
                          label="Non"
                          value="non"
                          checked={location === "non"}
                          onChange={handleChange}
                        />
                    </Col>
                </Row>
                <Row className="mt-3">
                  <Col className="d-flex justify-content-between">
                        <Button type="button" variant="secondary" onClick={prevStep}>
                            Précédent
                        </Button>
                        <Button type="submit" variant="primary" className="ms-3" disabled={!location ? true : false}>
                            Suivant
                        </Button>
                    </Col>
                </Row>
              </Form>
            </Container>
          );
        };
        
export default Step20;